import { useEffect } from 'react';

const BASE_TITLE = 'One Point | Powered by AOH';

/**
 * Prefixes the browser tab title with an unread count (e.g. "(3) One Point |
 * Powered by AOH") when count > 0, restoring the base title otherwise.
 */
export function useDocumentTitleBadge(count: number) {
  useEffect(() => {
    document.title = count > 0 ? `(${count}) ${BASE_TITLE}` : BASE_TITLE;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [count]);
}
